const isTypeMatching = (itemA: any, itemB: any) => {
    return typeof itemA === typeof itemB;
};

export default isTypeMatching;
